export const CREATE_CONTACT = 'CREATE_CONTACT'
export const GET_CONTACT = 'GET_CONTACT'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const DELETE_CONTACT = 'DELETE_CONTACT'
export const DELETE_ALL_CONTACT = 'DELETE_ALL_CONTACT'
export const SELECT_CONTACT = 'SELECT_CONTACT'
export const CLEAR_CONTACT = 'CLEAR_CONTACT'
